module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n\t投资者第一次登录APP，可直接在妥妥递首页输入邀请码进行管理\n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/invite.png"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "01"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1), _vm._v("\n\t已有关联管理人时，点击右上角关联管理人，输入邀请码进行关联 \n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe1",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange1
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/invite11.png"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/invite22.png"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep1,
      "total_step": "02"
    },
    on: {
      "leftClick": _vm.leftClick1,
      "rightClick": _vm.rightClick1
    }
  }, [_vm._v(_vm._s(_vm.message1))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bc653ee"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/inviteGuide.vue
// module id = 1041
// module chunks = 1